import React, { FC } from "react";
import { Skeleton } from "@mui/material";
import styles from './CorporateSkeleton.module.scss';

interface CorporateSkeletonProps {
  count?: number;
}

const CorporateSkeleton: FC<CorporateSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className={styles["corporate-list-container"]} style={{display:"flex", gap:"0"}}>

      {/* Content Skeleton */}
      <div className={styles["corporate-list-container__contents"]}>
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className={styles["corporate-list-container__contents__content"]}
          >
            {/* Left Section */}
            <div
              className={
                styles["corporate-list-container__contents__content__left"]
              }
            >
              <Skeleton
                variant="rounded"
                width={32}
                height={32}
                sx={{ borderRadius: "4px" }}
              />
              <Skeleton
                variant="text"
                width={200}
                height={24}
                sx={{ borderRadius: "4px" }}
              />
            </div>

            {/* Right Section */}
            <div
              className={
                styles["corporate-list-container__contents__content__right"]
              }
            >
              <Skeleton variant="circular" width={24} height={24} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CorporateSkeleton;
